// extracted by mini-css-extract-plugin
module.exports = {"root":"EllipsisText_root__y2txx","showLessButton":"EllipsisText_showLessButton__RB43q"};